<template>
	<div style="position: relative;">
		<div style="position: relative;min-height: 100vh;" class="bgs">
			<div style="padding-top: 30px;text-align: center;font-weight: bold;">
				<div style="font-size: 1.7rem;">{{'《'+book.bookname+'》'}}</div>
				<img :src="book.bookimg" style="margin-top: 20px;width: 45%;border-radius: 6px;" />
			</div>
			<div class="kuang">
				<span>简介：</span><span>{{book.bookintroduction}}</span>
			</div>
			<div class="kuang">
				<div>节目列表</div>
				<div style="margin-top: 20px;height: 220px;overflow-y: auto;">
					<div @click="goRead(index)" class="item" v-for="(item,index) in book.chapterlist">
						{{index+1}}.{{item.chaptername}}</div>
				</div>
			</div>
			<div style="text-align: center;margin-top: 25px;padding-bottom: 30px;">
				<img @click="back" src="../assets/back-button.png" style="width: 40%;padding: 0px 0 30px;" />
			</div>
			<div v-if="loading_flag"
				style="position: fixed;top: 0;left: 0;height: 100%;width: 100%;background-color: rgba(0,0,0,0.5);z-index: 999;">
				<img src="../assets/loading.gif"
					style="width: 30px;position: absolute;top: 45%;left: 50%;transform: translate(-50%);" />
			</div>
		</div>
		<div v-if="audio_flag"
			style="position: fixed;top: 0;left: 0;width: 100%;height: 100vh;background-color: rgba(0,0,0,0.7);">
			<div style="position: absolute;top: 50%;transform: translateY(-50%);width: 90%;left: 5%;">
				<div style="background-color: #fff;border-radius: 10px;box-sizing: border-box;padding: 25px 15px;width: 100%;">
					<div style="text-align: center;">
						<div style="font-size: 1.7rem;font-weight: bold;">{{'《'+book.bookname+'》'}}</div>
						<div style="font-size: 1.2rem;margin-top: 5px;">{{book.chapterlist[chapter_index].chaptername}}</div>
						<img :src="book.bookimg"
							style="margin-top: 20px;width: 50vw;border-radius: 6px;height: 60vw;object-fit: cover;" />
					</div>
					<div style="font-size: 0.85rem;display: flex;align-items: center;margin-top: 20px;">
						<div style="margin-right: 15px;">{{formatTime(currentTime)}}</div>
						<div style="width: 0;flex: 1;">
							<van-progress pivot-text="" color="#e51818" track-color="#7f7f7f" :percentage="percentage" />
						</div>
						<div style="margin-left: 15px;">{{formatTime(duration)}}</div>
					</div>
					<audio ref="audioPlayer" @timeupdate="updateTime" :src="book.chapterlist[chapter_index].chapterurl"
						@loadedmetadata="setupAudio" @ended="playEnd"></audio>
					<div style="font-size: 1.7rem;font-weight: bolder;margin-top: 20px;text-align: center;">当前积分：<span style="color: #e61818;">{{score}}</span>分</div>
					<div style="margin-top: 10px;text-align: center;">播完本章节获取20积分</div>
				</div>
				
				<div style="margin-top: 15px;text-align: center;">
					<img @click="tuichu" src="../assets/exit-play.png" style="width: 45%;" />
				</div>
			</div>
		</div>

	</div>

</template>

<script>
	import Vue from 'vue';
	import Toast from 'vant/lib/toast';
	import 'vant/lib/toast/style';
	
	import Progress from 'vant/lib/progress';
	import 'vant/lib/progress/style';
	Vue.use(Toast);
	Vue.use(Progress);
	export default {
		name: 'Book',
		components: {

		},
		data() {
			return {


				loading_flag: false,
				book: {

				},
				data: {},
				
				chapter_index:null,

				currentTime: 0,
				duration: 0,
				percentage: 0,
				
				audio_flag:false,
				
				
				ranknum:null,
				score:null,
				scoredifference:null,
				
				hideBeforeIsPlaying: false
			}
		},

		methods: {
			playEnd(){
				this.post_read()
				
			},
			getScore(){
				let post = {
					"jytoken": window.tokenss
				}
				post = JSON.stringify(post)
				this.$api.get('/formal_loginin.php', {
					params: {
						message: post
					}
				}).then((data) => {
					if(data.data.code==1){
						this.ranknum=data.data.data.ranknum
						this.score=data.data.data.score
						this.scoredifference=data.data.data.scoredifference
					}
					
				})
			},
			tuichu(){
				this.audio_flag = false
			},
			back() {
				this.$router.back()
			},
			goRead(index) {
				this.chapter_index = index
				this.audio_flag = true
				this.$nextTick(()=>{
					this.$refs.audioPlayer.play()
					// this.$refs.audioPlayer.currentTime = 1280
				})
			},

			setupAudio() {
				const audio = this.$refs.audioPlayer;
				this.duration = audio.duration;
			},
			updateTime() {
				const audio = this.$refs.audioPlayer;
				this.currentTime = audio.currentTime;
				this.percentage = this.currentTime/this.duration*100
			},
			formatTime(seconds) {
				let minutes = Math.floor(seconds / 60);
				let remainingSeconds = Math.floor(seconds % 60);
				return `${minutes < 10 ? '0' : ''}${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
			},
			post_read(){
				let post = {
					"jytoken": window.tokenss,
					"chapterid":this.book.chapterlist[this.chapter_index].chapterid
				}
				post = JSON.stringify(post)
				this.$api.post('/formal_receive.php', {message: post}).then((data) => {
					if(data.data.code==1){
						Toast('恭喜，成功获取20积分')
						if (this.chapter_index==this.book.chapterlist.length-1) {
							this.chapter_index = 0
						}else{
							this.chapter_index ++
						}
						this.$nextTick(()=>{
							this.$refs.audioPlayer.play()
							// this.$refs.audioPlayer.currentTime = 1280
						})
						this.getScore()
					}else{
						Toast(data.data.data)
						window.getNewToken()
					}
				}).catch(() => {
					Toast('提交失败，请重试')
					
				})
			}

		},
		mounted() {
				this.book = JSON.parse(decodeURIComponent(this.$route.query.book))
				this.getScore()
				
			
		}
	}
</script>

<style scoped>
	.bgs{
		background-image: url(../assets/bg.jpg);
		background-size: 100% 100%;
	}
	.kuang {
		margin: 0 4%;
		margin-top: 15px;
		padding: 20px 10px;
		box-sizing: border-box;
		box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
		border-radius: 6px;
		background-color: #fff;
		font-size: 1.1rem;
	}

	.item {
		width: 100%;
		background-color: #e4e4e4;
		border-radius: 20px;
		padding: 10px 20px;
		box-sizing: border-box;
		margin-bottom: 10px;
	}
</style>